import { render, staticRenderFns } from "./StudentTypeList.vue?vue&type=template&id=31b5d754"
import script from "./StudentTypeList.vue?vue&type=script&lang=js"
export * from "./StudentTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports